<template>
  <div class="deliver-order">
    <div class="date-info" @click="showDetail = !showDetail">
      <div class="date-time">配送日期：{{ deliveryItem.deliveryDateStr }}</div>
      <div class="order-amount">
        ￥{{ deliveryItem.orderAmount }}
        <IconFont
          v-if="deliveryItem.orderList.length > 0"
          :name="showDetail ? 'arrow_up_m' : 'arrow_down_m'"
          size="0.2rem"
          color="#999"
        />
      </div>
    </div>

    <div
      v-for="item in deliveryItem.orderList"
      v-show="showDetail"
      :key="item.orderId"
      class="order-item"
    >
      <div class="order-id">
        <div>订单编号：{{ item.orderId }}{{ item.tradeTypeTag || '' }}</div>
        <div>￥{{ item.orderAmount }}</div>
      </div>
      <div v-for="(ssu, index) in item.goodsList" :key="index" class="oi-item">
        <div class="name">{{ ssu.ssuName }}</div>
        <div class="property">
          <div class="property-item">规格：{{ ssu.ssuFormat }}</div>
          <div class="property-item">单位：{{ ssu.skuPriceUnit }}</div>
        </div>
        <div class="property">
          <div class="property-item">
            下单金额：￥{{ toFixd(ssu.orderAmount) }}
          </div>
          <div class="property-item">下单量：{{ ssu.priceNum }}</div>
        </div>
        <div class="property">
          <div class="property-item">实收量：{{ ssu.receivePriceNum }}</div>
          <div class="property-item">
            多退少补：{{ Number(ssu.diffAmount) >= 0 ? '' : '-' }}￥{{
              toFixd(Math.abs(ssu.diffAmount))
            }}
          </div>
        </div>
        <div class="property">
          <div class="property-item">
            退款金额：￥{{ toFixd(ssu.refundAmount) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeliverOrder',
  props: {
    deliveryItem: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showDetail: false
    }
  },

  methods: {
    toFixd(num) {
      return Number(num).toFixed(2)
    }
  }
}
</script>

<style lang="scss" scoped>
.date-info {
  display: flex;

  width: 7rem;
  height: 0.72rem;
  margin: 0 auto;
  padding: 0 0.24rem;

  background-color: #fff;

  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  font-size: 0.28rem;
  font-weight: 500;
  color: #262626;
}
.order-item {
  width: 7rem;
  margin: 0 auto 0.16rem;

  background-color: #fff;
  border-radius: 0.16rem;
  .order-id {
    height: 0.86rem;
    padding: 0 0.24rem;

    border-bottom: 1px solid #f5f5f5;

    font-size: 0.28rem;
    line-height: 0.86rem;
    color: #262626;

    @include flex-row-between;
  }
  .oi-item {
    padding: 0.2rem 0.24rem;

    border-bottom: 1px solid #f5f5f5;

    font-size: 0.24rem;
    line-height: 0.34rem;
    color: #8c8c8c;
    &:last-child {
      border: none;
    }
    .name {
      color: #262626;
    }
    .property {
      display: flex;

      margin-top: 0.08rem;
      .property-item {
        flex: 1;
      }
    }
  }
}
</style>
